import script from "./UserStartView.vue?vue&type=script&setup=true&lang=js"
export * from "./UserStartView.vue?vue&type=script&setup=true&lang=js"

import "./UserStartView.vue?vue&type=style&index=0&id=78bc75ca&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-78bc75ca"]])

export default __exports__